import React from "react";
import "./HomePage_ForListeners.css";

export function HomePageForListeners() {
  return (
    <iframe
      src="landing_listeners/index.html"
      title="tawkit - for Listeners"
      className="externalLanding"
    >
      Your browser doesnt support iframes
    </iframe>
  );
}
